import { I18n } from '@affine/i18n';

const AI_ACTION_I18N_KEYS: Record<string, string> = {
  'AI image filter anime style': 'com.streamlain.ai.action.image-filter-anime',
  'AI image filter clay style': 'com.streamlain.ai.action.image-filter-clay',
  'AI image filter pixel style': 'com.streamlain.ai.action.image-filter-pixel',
  'AI image filter sketch style':
    'com.streamlain.ai.action.image-filter-sketch',
  'Brainstorm ideas about this': 'com.streamlain.ai.action.brainstorm',
  'Brainstorm ideas with mind map':
    'com.streamlain.ai.action.brainstorm-mindmap',
  'Brainstorm mindmap': 'com.streamlain.ai.action.brainstorm-mindmap',
  'Change tone': 'com.streamlain.ai.action.change-tone',
  'Change tone to': 'com.streamlain.ai.action.change-tone-to',
  'Check code error': 'com.streamlain.ai.action.check-code-error',
  Clearer: 'com.streamlain.ai.action.clearer',
  'Continue in AI Chat': 'com.streamlain.ai.action.continue-in-ai-chat',
  'Continue writing': 'com.streamlain.ai.action.continue-writing',
  'Convert to sticker': 'com.streamlain.ai.action.convert-to-sticker',
  'Create a presentation': 'com.streamlain.ai.action.generate-presentation',
  'Create headings': 'com.streamlain.ai.action.generate-headings',
  'Expand from this mind map node':
    'com.streamlain.ai.action.expand-mindmap-node',
  'Expand mind map': 'com.streamlain.ai.action.expand-mindmap-node',
  'Explain selection': 'com.streamlain.ai.action.explain-selection',
  'Explain this': 'com.streamlain.ai.action.explain-this',
  'Explain this code': 'com.streamlain.ai.action.explain-code',
  'Explain this image': 'com.streamlain.ai.action.explain-image',
  'Find action items from it': 'com.streamlain.ai.action.find-actions',
  'Find actions': 'com.streamlain.ai.action.find-actions',
  'Fix grammar': 'com.streamlain.ai.action.fix-grammar',
  'Fix spelling': 'com.streamlain.ai.action.fix-spelling',
  'Fix spelling for it': 'com.streamlain.ai.action.fix-spelling',
  'Generate a caption': 'com.streamlain.ai.action.generate-caption',
  'Generate an image': 'com.streamlain.ai.action.generate-image',
  'Generate headings': 'com.streamlain.ai.action.generate-headings',
  'Generate outline': 'com.streamlain.ai.action.generate-outline',
  'Generate presentation': 'com.streamlain.ai.action.generate-presentation',
  'Improve grammar for it': 'com.streamlain.ai.action.fix-grammar',
  'Improve writing': 'com.streamlain.ai.action.improve-writing',
  'Improve writing for it': 'com.streamlain.ai.action.improve-writing',
  'Make it longer': 'com.streamlain.ai.action.make-longer',
  'Make it real': 'com.streamlain.ai.action.make-it-real',
  'Make it shorter': 'com.streamlain.ai.action.make-shorter',
  'Regenerate mind map': 'com.streamlain.ai.action.regenerate-mindmap',
  'Remove background': 'com.streamlain.ai.action.remove-background',
  Summarize: 'com.streamlain.ai.action.summarize',
  Summary: 'com.streamlain.ai.action.summarize',
  Translate: 'com.streamlain.ai.action.translate',
  'Translate to': 'com.streamlain.ai.action.translate-to',
  'Write a blog post about this': 'com.streamlain.ai.action.write-blog-post',
  'Write a poem about this': 'com.streamlain.ai.action.write-poem',
  'Write a tweet about this': 'com.streamlain.ai.action.write-tweet',
  'Write an article about this': 'com.streamlain.ai.action.write-article',
  'Write outline': 'com.streamlain.ai.action.generate-outline',
  image: 'com.streamlain.ai.action.generate-image',
};

const AI_GROUP_I18N_KEYS: Record<string, string> = {
  'draft from text': 'com.streamlain.ai.action.group.draft-from-text',
  'edit text': 'com.streamlain.ai.action.group.edit-text',
  'generate from text': 'com.streamlain.ai.action.group.generate-from-text',
  others: 'com.streamlain.ai.action.group.others',
  Others: 'com.streamlain.ai.action.group.others',
  'review code': 'com.streamlain.ai.action.group.review-code',
  'review image': 'com.streamlain.ai.action.group.review-image',
  'review text': 'com.streamlain.ai.action.group.review-text',
};

const AI_SUB_ITEM_I18N_KEYS: Record<string, string> = {
  'Brazilian Portuguese': 'com.streamlain.ai.action.lang.brazilian-portuguese',
  Critical: 'com.streamlain.ai.action.tone.critical',
  English: 'com.streamlain.ai.action.lang.english',
  French: 'com.streamlain.ai.action.lang.french',
  Friendly: 'com.streamlain.ai.action.tone.friendly',
  German: 'com.streamlain.ai.action.lang.german',
  Humorous: 'com.streamlain.ai.action.tone.humorous',
  Informal: 'com.streamlain.ai.action.tone.informal',
  Italian: 'com.streamlain.ai.action.lang.italian',
  Japanese: 'com.streamlain.ai.action.lang.japanese',
  Korean: 'com.streamlain.ai.action.lang.korean',
  Professional: 'com.streamlain.ai.action.tone.professional',
  Russian: 'com.streamlain.ai.action.lang.russian',
  'Simplified Chinese': 'com.streamlain.ai.action.lang.simplified-chinese',
  Spanish: 'com.streamlain.ai.action.lang.spanish',
  'Traditional Chinese': 'com.streamlain.ai.action.lang.traditional-chinese',
};

const translateMapped = (value: string, map: Record<string, string>) => {
  const key = map[value];
  return key ? I18n.t(key) : value;
};

export const localizeAIActionName = (name: string) =>
  translateMapped(name, AI_ACTION_I18N_KEYS);

export const localizeAIGroupName = (name: string) =>
  translateMapped(name, AI_GROUP_I18N_KEYS);

export const localizeAISubItemType = (type: string) =>
  translateMapped(type, AI_SUB_ITEM_I18N_KEYS);

export const localizeAIActionFromAbove = (name: string) =>
  I18n.t('com.streamlain.ai.action.from-above', {
    name: localizeAIActionName(name),
  });

export const localizeAIActionBetaLabel = () =>
  I18n.t('com.streamlain.ai.action.beta');

export const localizeAIActionAnswerLabel = () =>
  I18n.t('com.streamlain.ai.action.answer');

export const localizeAIActionPromptLabel = () =>
  I18n.t('com.streamlain.ai.action.prompt');
